import { createSlice } from '@reduxjs/toolkit';
import { fetchAdminEmails, updateEmailInvite, fetchCustomerList } from '../actions/adminActions';

const initialState = {
  emails: [],
  customerList: [],
  customerCount: 0,
  loading: false,
  error: null,
};

const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdminEmails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAdminEmails.fulfilled, (state, action) => {
        state.loading = false;
        state.emails = action.payload;
      })
      .addCase(fetchAdminEmails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.error || 'Failed to fetch emails';
      })
      .addCase(updateEmailInvite.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateEmailInvite.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updateEmailInvite.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.error || 'Failed to update invite';
      })
      .addCase(fetchCustomerList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCustomerList.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload) {
          state.customerList = action.payload.customers || [];
          state.customerCount = action.payload.count || 0;
        } else {
          state.customerList = [];
          state.customerCount = 0;
        }
      })
      .addCase(fetchCustomerList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.error || 'Failed to fetch customer list';
      });
  },
});

export default adminSlice.reducer;
